import type { SVGProps } from 'react'
const SvgSyDateRange = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M3 10c0-1.886 0-2.828.586-3.414S5.114 6 7 6h10c1.886 0 2.828 0 3.414.586S21 8.114 21 10z"
		/>
		<path d="M5 5.4C3.57 5.4 2.4 6.57 2.4 8v11c0 1.43 1.17 2.6 2.6 2.6h14c1.43 0 2.6-1.17 2.6-2.6V8c0-1.43-1.17-2.6-2.6-2.6zm0 1.2h14c.786 0 1.4.614 1.4 1.4v11c0 .786-.614 1.4-1.4 1.4H5c-.786 0-1.4-.614-1.4-1.4V8c0-.786.614-1.4 1.4-1.4" />
		<path d="M7 2.4a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6V3a.6.6 0 0 0-.6-.6m10 0a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6V3a.6.6 0 0 0-.6-.6" />
		<rect width={4} height={2} x={7} y={12} rx={0.5} />
		<rect width={4} height={2} x={7} y={16} rx={0.5} />
		<rect width={4} height={2} x={13} y={12} rx={0.5} />
		<rect width={4} height={2} x={13} y={16} rx={0.5} />
	</svg>
)
export default SvgSyDateRange
